import React, { SVGProps } from 'react';

const SvgCustomWidget = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlSpace='preserve' width="1em" height="1em" fill="none" viewBox="0 0 24 24" className='svg-icon'  {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M9 3.30273H4C3.44772 3.30273 3 3.75045 3 4.30273V9.30273C3 9.85502 3.44772 10.3027 4 10.3027H9C9.55228 10.3027 10 9.85502 10 9.30273V4.30273C10 3.75045 9.55228 3.30273 9 3.30273Z" stroke="#4B4B4B" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M9 14.3027H4C3.44772 14.3027 3 14.7504 3 15.3027V20.3027C3 20.855 3.44772 21.3027 4 21.3027H9C9.55228 21.3027 10 20.855 10 20.3027V15.3027C10 14.7504 9.55228 14.3027 9 14.3027Z" stroke="#4B4B4B" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M20 3.30273H15C14.4477 3.30273 14 3.75045 14 4.30273V9.30273C14 9.85502 14.4477 10.3027 15 10.3027H20C20.5523 10.3027 21 9.85502 21 9.30273V4.30273C21 3.75045 20.5523 3.30273 20 3.30273Z" stroke="#4B4B4B" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M17.5 14.3027V21.3027M21 17.8027H14" stroke="#4B4B4B" stroke-width="1.5" stroke-linecap="round"/>
    </svg>


);

export default SvgCustomWidget;